import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import times from 'lodash.times';

import Modal from '../titled-modal/titled-modal.jsx';

import styles from './submit-comment.css';

const sortBy = attr => ((a, b) => {
    a = a[attr];
    b = b[attr];
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
});
const CommentListItem = props => (<div
    className={classNames(styles.commentListItem, {
        [styles.separator]: props.keys === 2
    }, {
        [styles.commentListItemBackgroundColor]: props.type === 1
    })}
    key={props.keys}
>
    <div
        className={classNames(styles.commentListBrefContent)}
    >
        <div
            className={styles.btnCheckListItemContent}
            data-key={props.keys}
            role="button"
            tabIndex={0}
            onClick={props.onClickCommentlistItm}
        >
            <input
                checked={props.keys === props.commentListCheck}
                className={styles.commentDisc}
                type="radio"
            />
            <span className={styles.commentListText}>{props.content}</span>
        </div>
        <span
            className={classNames(styles.btnDetailDown, {
                [styles.btnDetailUp]: props.itemShowDetail === props.keys
            })}
            data-key={props.keys}
            role="button"
            tabIndex={0}
            onClick={props.onClickShowDet}
        />
    </div>
    {
        props.itemShowDetail === props.keys &&
        <div className={styles.commentItemDetail}>
            {props.content}
        </div>
    }
</div>);
CommentListItem.propTypes = {
    commentListCheck: PropTypes.Number,
    content: PropTypes.String,
    itemShowDetail: PropTypes.number,
    keys: PropTypes.number,
    onClickCommentlistItm: PropTypes.func,
    onClickShowDet: PropTypes.func,
    type: PropTypes.number
};

const SubmitCommentModalComponent = props => (
    <Modal
        className={styles.modalContent}
        isOpen={props.isOpen}
        overlayClassName={styles.modalOverlay}
        onRequestClose={props.onCloseRequest}
    >
        <div
            className={styles.submitCommentModalContainer}
        >
            <div
                className={styles.submitCommentTitleContainer}
            >
                <div className={styles.submitCommentTitle}>{'修改'}</div>
                <span className={styles.submitCommentSeparateLine} />
            </div>
            <div
                className={styles.submitCommentContainer}
            >
                {
                    props.commentList.sort(sortBy('sequence')).map((item, key) => (
                        <CommentListItem
                            commentListCheck={props.commentListChecked}
                            content={item.content}
                            itemShowDetail={props.itemShowDetail}
                            key={key}
                            keys={key}
                            type={item.type}
                            onClickCommentlistItm={props.onClickCommentlistItem}
                            onClickShowDet={props.onClickShowDetail}
                        />
                    ))
                }
                <div>
                    <div className={styles.commentContainer}>
                        <div className={styles.commentTitleContent}>
                            <span className={styles.commentIcon}>{'*'}</span>
                            <span className={styles.commentText}>{'评语:'}</span>
                        </div>
                        <textarea
                            className={styles.commentContent}
                            id="comment-content-textarea"
                            onBlur={props.onCommentContentBlur}
                        />
                        {
                            props.commentTipsState && (
                                <div className={styles.commentWarningTips}>{'* 评语不能为空'}</div>
                            )
                        }
                    </div>
                    <div className={styles.gradeContainer}>
                        <div className={styles.gradeTitleContent}>
                            <span className={styles.gradeIcon}>{'*'}</span>
                            <span className={styles.gradeText} >{'打分:'}</span>
                        </div>
                        <div
                            className={styles.gradeStartContent}
                            data-level={-1}
                            role="button"
                            tabIndex={0}
                            onMouseOut={props.onMouseOverGradeStarBlink}
                        >
                            {
                                times(5, key => (
                                    <div
                                        className={styles.gradeStarBackground}
                                        data-level={key + 1}
                                        key={key}
                                        role="button"
                                        tabIndex={0}
                                        onClick={props.onClickGradeLevel}
                                        onMouseOver={props.onMouseOverGradeStarBlink}
                                    >
                                        <span className={styles.gradeStar} />
                                        <span
                                            className={classNames(styles.gradeStarBackgroundLeft, {
                                                [styles.gradeStarGrey]: key + 1 > props.gradeStarBlink
                                            })}
                                        />
                                        <span
                                            className={classNames(styles.gradeStarBackgroundRight, {
                                                [styles.gradeStarGrey]: key + 1 > props.gradeStarBlink
                                            })}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                        {
                            props.gradeTipsState && (
                                <div className={styles.gradeWarningTips}>{'* 请打分'}</div>
                            )
                        }
                    </div>
                </div>
            </div>
            <div className={styles.btnContainer}>
                <span className={styles.btnSeparateLine} />
                <div className={styles.btnContent}>
                    <div
                        className={styles.btnCancel}
                        role="button"
                        tabIndex={0}
                        onClick={props.onClickBtnCancel}
                    >
                        {'取消'}
                    </div>
                    {props.isTutor ? null : (<div
                        className={styles.btnIgnore}
                        role="button"
                        tabIndex={0}
                        onClick={props.onClickBtnIgnore}
                    >
                        {'忽略'}
                    </div>)}
                    <div
                        className={styles.btnConfirm}
                        role="button"
                        tabIndex={0}
                        onClick={props.onClickBtnConfirm}
                    >
                        {'确定'}
                    </div>
                </div>
            </div>
        </div>
    </Modal>
);

SubmitCommentModalComponent.propTypes = {
    commentList: PropTypes.shape(PropTypes.array),
    commentListChecked: PropTypes.number,
    commentTipsState: PropTypes.bool,
    gradeStarBlink: PropTypes.number,
    gradeTipsState: PropTypes.bool,
    isOpen: PropTypes.bool,
    isTutor: PropTypes.bool,
    itemShowDetail: PropTypes.number,
    onClickBtnCancel: PropTypes.func,
    onClickBtnConfirm: PropTypes.func,
    onClickBtnIgnore: PropTypes.func,
    onClickCommentlistItem: PropTypes.func,
    onClickGradeLevel: PropTypes.func,
    onClickShowDetail: PropTypes.func,
    onCloseRequest: PropTypes.func,
    onCommentContentBlur: PropTypes.func,
    onMouseOverGradeStarBlink: PropTypes.func
};

export default SubmitCommentModalComponent;
